import React , { useRef } from 'react';
import {
    Show,
    SimpleShowLayout,
    CardActions,
    ListButton
} from 'react-admin';
//import { Checkmark } from 'react-checkmark'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import PrintExam from './PrintExam'

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <div ><PrintExam record={record} classes={classes} ref={componentRef} /></div>
            <br />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
};

const useStyles = makeStyles({
    root: {  
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: "775px",
        maxWidth: '800',            
        alignItems: 'middle',
        margin: "20px 10px 2px 20px",  
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },
    p: {
        fontSize: '12px',
    },
    p2: {
        fontSize: '9px',
        textAlign: 'right'
    },
})

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  };

var questions = [];
var answers=[]

const ExamActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/Certifications'} label="Certification List" />
    </CardActions>
  );
  
  
const Exam=({record})=>{
    const classes = useStyles();
    if(record && record.questions){
        try{
          questions =JSON.parse(record.questions) 
        } catch(e) {
          questions = record.questions;
        };
    }

    if(record && record.answers){
        try{
            answers =record.answers.split(',')
        } catch(e) {
        };
    }

    return(
  
        <div>
        {questions && questions.map((item, index) =>(
            <p key={index}><font color="navy" size="2">{index + 1}) {item['quest']}<br/></font>
            {item['Choices'] && item['Choices'].map((ans, i)=>
                <span  key={i+500}><font color={"grey"} size="2" >&nbsp;&nbsp;&nbsp;{i + 1}.</font>
                    <input type="radio" value={ans['answer']} name={index} checked={ans['answer'] === answers[index]? true: false} disabled/>
                    <font color={ans['isAnswere']? "green" : "grey"} size="2">{ans['answer']}
                    {(ans['answer'] === answers[index])&& ans['isAnswere']?  <span>&nbsp;&#10004;</span>: ''}
                    {(ans['answer'] === answers[index])&& !ans['isAnswere']? <span><font color='red'>&nbsp;&#10060;</font></span>: ''}</font><br/>
                </span>
                )
            }
            </p>
        ))
        }
        <hr/>
        <p className={classes.p2}><span>** Passing Socre:&nbsp;{record.passing_per}%</span></p>
        </div>
    )
}

const ExamHeader=({record})=>{
    const classes = useStyles();
    return(
        <div className={classes.title}>
            <h2>{(record.training_name)?((record.training_name)?record.training_name:''):''}</h2>
            <h3>{(record.exam_name)?((record.exam_name)?record.exam_name:''):''}</h3>
            <p className={classes.p}>
                <b>Candidate:&nbsp;</b>{record.full_name?record.full_name:''}&nbsp;&nbsp;&nbsp;&nbsp;
                <b>Exam Result:&nbsp;</b>{record.ispass===1? 'PASS' : 'FAIL'}&nbsp;({record.marks_per}%)&nbsp;&nbsp;&nbsp;&nbsp;
                <b>Exam Date:&nbsp;</b>{moment(Date()).format('MM/DD/yyyy')}</p>
        </div>
    )
}


const ExamlogShow = ({...props }) => (
    <Show  
       
        actions={<ExamActions />}
        {...props}
    >
        <SimpleShowLayout >  
            <Print  />
        </SimpleShowLayout >     
    </Show>
)

export default ExamlogShow;